export class PaginationModel {
    private _page:number = 1;    

    constructor(page?:number) {
        if (!page || page < 1) {
            page = 1;
        }

        this._page = page;
    }

    actual():number {
        return this._page;
    }

    next():number {
        this._page += 1;
        return this._page;
    }

    previous():number {
        this._page -= 1;

        if (this._page < 1) {
            this._page = 1;
        }

        return this._page;
    }

    update(page:number):number {
        if (page < 1) {
            page = 1;
        }

        this._page = page;
        return this._page;
    }

    reset():number {
        this._page = 1;
        return this._page;
    }
}
